import { useEffect, useState, useRef } from 'react'
import { connectState, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { View } from "base/src/components/Basic/View/view"

import { RootStateBase } from '../../../store/baseStore';

import * as S from './styles'
import { Button } from '../../../components/Button';
import { Icon } from '@iconify/react';
import { ERROR_CLEAR } from 'domain/types/base/base';
import { StoreAplication } from '../../../main';

const connector = connectState(
  (state: RootStateBase) => ({
    error: state.BaseReducer.Error,
  })
);

export interface ErrorProps extends PropsFromRedux<typeof connector> {
  stateNames: string[];
}

function Error (props: ErrorProps) {
	const erro = props.error.find((e) => props.stateNames.includes(e.Name));

	const textButton = typeof erro?.CallBack !== 'function' ? erro?.CallBack?.CallBackText : "Tentar Novamente!";
    const closeText = typeof erro?.CallBack !== 'function' ? (erro?.CallBack?.CloseText ?? null) : "Fechar";

	function handleClick() {
		if (typeof erro?.CallBack === 'function') {
            erro.CallBack();
        }else{
            erro?.CallBack.CallBack();
        }

		close()
	}


	function close() {
	
		StoreAplication.dispatch(
			{
				payload: erro?.Name,
				type: ERROR_CLEAR
			})
	}


	const [size, setSize] = useState<{ w: number, h: number }>()
	const ref = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (ref && ref.current) {
			setSize({ w: ref.current.clientWidth, h: ref.current.clientHeight })
		}
	}, [])

	return (
		props.error.find((e) => props.stateNames.includes(e.Name)) &&
		<S.Error ref={ref} className='fullCenter'>
			<View style={{ width: "100%", height: "100%", padding: "20px" }}>
				<View style={{ overflow: "scroll", maxHeight: "80%" }}>
					<S.ErrorText>
						{erro &&
							<View>{erro.Message}</View>
						}
					</S.ErrorText>
				</View>
				{erro?.CallBack != undefined &&
					<View className='fullCenter' style={{ marginTop: "20px", flexDirection:"column", gap:15 }}>
						<Button style={{ maxHeight: size?.h }} onClick={handleClick} type='button' iconPosition='left' size='xsm' >
							<Icon icon="mdi-refresh" height="18px" color={"white"} />
							{textButton}
						</Button>
						{closeText != null && 
							<Button style={{ maxHeight: size?.h }} onClick={close} type='button' iconPosition='left' size='xsm' >
								<Icon icon="mdi-close" height="18px" color={"red"} />
								{closeText}
							</Button>
						}
					</View>
				}
			</View>
		</S.Error>


	)
}

const ConnectedError = connector(Error);
export default ConnectedError;
